import React from 'react';
import { Route } from '../Routing/types';
import { Sex, Height, DateOfBirth, UserSummary } from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: '/sex',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <Sex />,
  },
  {
    path: '/birth-date',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DateOfBirth />,
  },
  {
    path: '/height',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <Height />,
  },
  {
    path: '/summary',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <UserSummary />,
  },
];

export default descendantRoutes;
